import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { DialogAction } from '../../../function/useModal';
import { useTranslation } from 'react-i18next';

type MessageDialogProps = {
  dialog: DialogAction<MessageDialogResponse>;
  title?: string;
  message: string;
  action?: string;
};

export type MessageDialogResponse = {};

const useStyles = makeStyles(
  createStyles({
    button: {
      width: '150px',
    },
  })
);

const MessageDialog: React.FC<MessageDialogProps> = (props: MessageDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);

  const msgs = props.message.split('\n');

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        onEntered={(e) => {}}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle>{props.title ?? t('MessageDialog.確認', '確認')}</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flow' }}>
            {msgs.map((msg, index) => (
              <div key={index}>{msg}</div>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={(e) => {
              setIsOpen(false);
              setMode(true);
            }}
          >
            {props.action ?? 'OK'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MessageDialog;
